import { FC } from "react";
import Dropdown, { Option } from "react-dropdown";
import "react-dropdown/style.css";

export interface GuestsInputProps {
  className?: string;
  room: any;
  maxGuests: number;
  formik?: any;
  disabled?: boolean;
}

const SelectGuests: FC<GuestsInputProps> = ({
  className = "flex-1",
  room,
  maxGuests,
  formik,
  disabled,
}) => {
  const options = Array.from({ length: maxGuests }, (_, i) =>
    (i + 1).toString()
  );

  const guests = formik?.values?.number_of_guests;
  const selectedRoom = formik?.values?.room_id;

  const onChange = (value: Option, roomId: number) => {
    formik.setFieldValue("room_id", roomId);
    formik.setFieldValue("number_of_guests", value.value);
  };

  return (
    <>
      <style>
        {`
          /* Base dropdown control */
          .nomad-guest-dropdown .Dropdown-control {
            display: flex;
            align-items: center;
            height: 44px;
            padding: 0 12px;
            background: #ffffff;
            border: 1.5px solid #e5e7eb !important;
            border-radius: 12px !important;
            font-size: 0.9375rem;
            font-weight: 450;
            color: #1f2937;
            cursor: pointer;
            transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
          }

          .nomad-guest-dropdown .Dropdown-control:hover {
            border-color: #d1d5db !important;
            background: #f9fafb;
          }

          .nomad-guest-dropdown.is-open .Dropdown-control {
            border-color: #3b82f6 !important;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
            background: #ffffff;
          }

          .nomad-guest-dropdown .Dropdown-disabled .Dropdown-control {
            background: #f3f4f6;
            border-color: #e5e7eb !important;
            color: #9ca3af;
            cursor: not-allowed;
            opacity: 0.6;
          }

          /* Placeholder text */
          .nomad-guest-dropdown .Dropdown-placeholder {
            color: #9ca3af;
            font-weight: 400;
            font-size: 0.9375rem;
          }

          /* Selected value */
          .nomad-guest-dropdown .Dropdown-placeholder.is-selected {
            color: #1f2937;
            font-weight: 450;
          }

          /* Arrow */
          .nomad-guest-dropdown .Dropdown-arrow-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .nomad-guest-dropdown .Dropdown-arrow {
            border-color: #9ca3af transparent transparent !important;
            border-width: 5px 5px 0 !important;
            margin-left: 8px;
            transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
          }

          .nomad-guest-dropdown.is-open .Dropdown-arrow {
            border-color: #3b82f6 transparent transparent !important;
            transform: rotate(180deg);
          }

          /* Dropdown menu */
          .nomad-guest-dropdown .Dropdown-menu {
            position: absolute;
            top: calc(100% + 4px);
            left: 0;
            right: 0;
            z-index: 1000;
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
            padding: 6px;
            max-height: 240px;
            overflow-y: auto;
            animation: slideDown 0.2s ease-out;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-8px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Individual options */
          .nomad-guest-dropdown .Dropdown-option {
            padding: 10px 12px;
            border-radius: 8px;
            font-size: 0.9375rem;
            font-weight: 450;
            color: #374151;
            cursor: pointer;
            transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
          }

          .nomad-guest-dropdown .Dropdown-option:hover {
            background: #eff6ff;
            color: #2563eb;
          }

          .nomad-guest-dropdown .Dropdown-option.is-selected {
            background: #eff6ff;
            color: #2563eb;
            font-weight: 500;
          }

          /* ==========================================
             DARK MODE
             ========================================== */

          .dark .nomad-guest-dropdown .Dropdown-control {
            background: #1f2937;
            border-color: #374151 !important;
            color: #f3f4f6;
          }

          .dark .nomad-guest-dropdown .Dropdown-control:hover {
            border-color: #4b5563 !important;
            background: #374151;
          }

          .dark .nomad-guest-dropdown.is-open .Dropdown-control {
            border-color: #3b82f6 !important;
            background: #1f2937;
          }

          .dark .nomad-guest-dropdown .Dropdown-disabled .Dropdown-control {
            background: #111827;
            border-color: #374151 !important;
          }

          .dark .nomad-guest-dropdown .Dropdown-placeholder {
            color: #6b7280;
          }

          .dark .nomad-guest-dropdown .Dropdown-placeholder.is-selected {
            color: #f3f4f6;
          }

          .dark .nomad-guest-dropdown .Dropdown-arrow {
            border-color: #6b7280 transparent transparent !important;
          }

          .dark .nomad-guest-dropdown.is-open .Dropdown-arrow {
            border-color: #3b82f6 transparent transparent !important;
          }

          .dark .nomad-guest-dropdown .Dropdown-menu {
            background: #1f2937;
            border-color: #374151;
          }

          .dark .nomad-guest-dropdown .Dropdown-option {
            color: #e5e7eb;
          }

          .dark .nomad-guest-dropdown .Dropdown-option:hover {
            background: #374151;
            color: #60a5fa;
          }

          .dark .nomad-guest-dropdown .Dropdown-option.is-selected {
            background: #374151;
            color: #60a5fa;
          }

          /* ==========================================
             RESPONSIVE
             ========================================== */

          @media (max-width: 480px) {
            .nomad-guest-dropdown .Dropdown-control {
              height: 48px;
              font-size: 1rem;
            }

            .nomad-guest-dropdown .Dropdown-placeholder {
              font-size: 1rem;
            }

            .nomad-guest-dropdown .Dropdown-option {
              padding: 12px 14px;
              font-size: 1rem;
            }
          }

          /* Touch devices */
          @media (hover: none) and (pointer: coarse) {
            .nomad-guest-dropdown .Dropdown-control {
              height: 48px;
            }

            .nomad-guest-dropdown .Dropdown-option {
              padding: 14px 12px;
            }
          }

          /* Reduced motion */
          @media (prefers-reduced-motion: reduce) {
            .nomad-guest-dropdown .Dropdown-control,
            .nomad-guest-dropdown .Dropdown-arrow,
            .nomad-guest-dropdown .Dropdown-option {
              transition: none;
            }

            .nomad-guest-dropdown .Dropdown-menu {
              animation: none;
            }
          }
        `}
      </style>

      <div className={className}>
        <Dropdown
          options={options}
          onChange={(value) => onChange(value, room.id)}
          value={selectedRoom === room.id ? guests : undefined}
          placeholder="Select Guests"
          className="nomad-guest-dropdown"
          disabled={disabled}
        />
      </div>
    </>
  );
};

export default SelectGuests;
